import { Flex } from "@eworkit/iris";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Attachment } from "@/data/attachments";
import { IConsultantProfileDto } from "@/data/consultant-profiles";

import { IPrivatePersonCvFormValues, PrivatePersonCvFormik } from "./PrivatePersonCvForm";

interface IPrivatePersonUploadCvProps {
  profile: IConsultantProfileDto;
  onSkipQuickSetup?: () => void;
  onSkipCV?: () => void;
  onCancel: () => void;
  onCvParsed: (cv?: Attachment) => void;
  hideBackButton?: boolean;
}

export const PrivatePersonUploadCv: FC<IPrivatePersonUploadCvProps> = props => {
  const { t } = useTranslation("session");

  const handleSubmit = async (values: IPrivatePersonCvFormValues) => {
    props.onCvParsed(values.cv?.attachment ? { ...values.cv?.attachment, defaultFile: true } : undefined);
  };

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" gap="md" pt="md">
      <Header size="md" weight="bold" color="black">
        {t("ONBOARDING.PROFILE_TYPE_SELECT.PRIVATE_PERSON.UPLOAD_CV.HEADER")}
      </Header>

      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Text size="lg" color="black">
          {t("ONBOARDING.PROFILE_TYPE_SELECT.PRIVATE_PERSON.UPLOAD_CV.TEXT1")}
        </Text>
        <Text size="lg" color="black">
          {t("ONBOARDING.PROFILE_TYPE_SELECT.PRIVATE_PERSON.UPLOAD_CV.TEXT2")}
        </Text>
      </Flex>

      <PrivatePersonCvFormik
        initialValues={{ cv: props.profile.cvs?.length ? { attachment: props.profile.cvs?.[0] } : undefined }}
        onSubmit={handleSubmit}
        onCancel={props.onCancel}
        onSkipQuickSetup={props.onSkipQuickSetup}
        onSkipCV={props.onSkipCV}
        hideBackButton={props.hideBackButton}
      />
    </Flex>
  );
};
